import React from 'react';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ContentElement = ({ image, alt, text, numElements}) => (
  <Col sm={6} lg={numElements <= 3 ? 4 : 3} className="px-4 mb-5">
    <div className="text-center">
      <img src={image} alt={alt}></img>
    </div>
    <p>{text}</p>
  </Col>
);


ContentElement.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string,
  text: PropTypes.string,
  numElements: PropTypes.number,
};

export default ContentElement;